import { useDispatch, useSelector } from "react-redux";
import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import { GetObjectiveProjectsList } from "../../Redux/Reducers/ReportStage/Objective";
import { GetListReportsStagesByApplicationInformationGUID } from "../../Redux/Reducers/ReportStage/Stages";
import './style.css'
import Swal from 'sweetalert2'
import $ from "jquery";
import { useEffect, useState } from "react";
import InputAHSF from "../../Components/InputAHSF";
import { AddExpectedObjectivesForStage, GetOneRecordExpectedObjectivesForStage, UpdateExpectedObjectivesForStageByStageId } from "../../Redux/Reducers/ReportStage/ExpectedObjectivesForStag";

const AddExpectedObjectivesForReport = (props) => {
    const [reportsStages, setReportsStages] = useState(null)
    const [Objectives, setObjectives] = useState(null)
    const [SubObjectives, setSubObjectives] = useState(null)
    const [subObjectivesPercentage, setSubObjectivesPercentage] = useState(null)

    const [reportsStagesValidation, setReportsStagesValidation] = useState(false)
    const [ObjectivesValidation, setObjectivesValidation] = useState(false)
    const [SubObjectivesValidation, setSubObjectivesValidation] = useState(false)
    const [subObjectivesPercentageValidation, setsubObjectivesPercentageValidation] = useState(false)



    const dispatch = useDispatch()
    const reports = useSelector((state) => state.ReportByAppGuidReducers.ReportByApp)


    useEffect(() => {
        dispatch(GetListReportsStagesByApplicationInformationGUID({ aI_ApplicationInformationId: props.appGuid }))
        if (reports?.pR_ReportsId) {
            dispatch(GetObjectiveProjectsList({ pR_ReportsId: reports?.pR_ReportsId }))

        }
    }, [props.appGuid])
    const ReportsStagesList = useSelector((state) => state.Stages.ListReportsStages)
    const objectiveProjectsList = useSelector((state) => state.ObjectiveReducer.ObjectiveList)

    const addExpectedObjectivesForReport = () => {

        if (reportsStages == null) {
            setReportsStagesValidation(true)
        } else {
            setReportsStagesValidation(false)
        }
        if (Objectives == null) {
            setObjectivesValidation(true)
        } else {
            setObjectivesValidation(false)
        }
        if (SubObjectives == null) {
            setSubObjectivesValidation(true)
        } else {
            setSubObjectivesValidation(false)
        }
        if (subObjectivesPercentage == null) {
            setsubObjectivesPercentageValidation(true)
        } else {
            setsubObjectivesPercentageValidation(false)

        }


        if (reportsStages != null && Objectives != null && SubObjectives != null && subObjectivesPercentage != null) {
            dispatch(AddExpectedObjectivesForStage({
                pR_ObjectiveProjectsId: Objectives,
                pR_ReportsStagesGuid: reportsStages,
                subObjectives: SubObjectives,
                pR_ReportsId: reports?.pR_ReportsId,
                percentageMainAndSubObjecive: subObjectivesPercentage
            }))
            $(".close-btn").trigger("click"); // Simulate click to close modal

            Swal.fire({
                position: "center",
                icon: "success",
                title: "تم اضافة المعلومات بنجاح", // Success message in Arabic
                showConfirmButton: false,
                timer: 1500, // Auto-close after 1.5 seconds
            });
        }

    }


    const editExpectedObjectivesForReport = () => {
        if (reportsStages == null) {
            setReportsStagesValidation(true)
        } else {
            setReportsStagesValidation(false)
        }
        if (Objectives == null) {
            setObjectivesValidation(true)
        } else {
            setObjectivesValidation(false)
        }
        if (SubObjectives == null) {
            setSubObjectivesValidation(true)
        } else {
            setSubObjectivesValidation(false)
        }
        if (subObjectivesPercentage == null) {
            setsubObjectivesPercentageValidation(true)
        } else {
            setsubObjectivesPercentageValidation(false)

        }

        if (reportsStages != null && Objectives != null && SubObjectives != null && subObjectivesPercentage != null) {
            dispatch(UpdateExpectedObjectivesForStageByStageId({
                pR_ExpectedObjectivesForStageId: props.pR_ExpectedObjectivesForStageId,
                pR_ObjectiveProjectsId: Objectives,
                pR_ReportsStagesGuid: expectedObjectivesForStage.pR_ReportsStagesGuid,
                subObjectives: SubObjectives,
                percentageMainAndSubObjecive: subObjectivesPercentage,
                descriptionOfAchievementOfSubGoals: null,
                achievementOfSubGoals: null,
                remainingCompletionGoal: null,
                canEdit: expectedObjectivesForStage.canEdit,
                pR_ReportsId: expectedObjectivesForStage.pR_ReportsId,
            }))
            $(".close-btn").trigger("click"); // Simulate click to close modal

            Swal.fire({
                position: "center",
                icon: "success",
                title: "تم اضافة المعلومات بنجاح", // Success message in Arabic
                showConfirmButton: false,
                timer: 1500, // Auto-close after 1.5 seconds
            });
        }

    }

    useEffect(() => {



        if (props.tackAction == "edit" && props.pR_ExpectedObjectivesForStageId != undefined || props.pR_ExpectedObjectivesForStageId != "undefined") {
            dispatch(GetOneRecordExpectedObjectivesForStage({ pR_ExpectedObjectivesForStageId: props.pR_ExpectedObjectivesForStageId }))
        }
        console.log(props.pR_ExpectedObjectivesForStageId, "skdjksjdkjsjdsd");

    }, [props.pR_ExpectedObjectivesForStageId])

    const expectedObjectivesForStage = useSelector((state) => state.ExpectedObjectivesForStage.ExpectedObjectivesForStage)

    console.log(expectedObjectivesForStage, "jshdjhsjhdjhsd");



    return (
        <>
            {
                <>

                    <AllDropDownsAHSF
                        fieldsName="ExStages"
                        show={true}
                        disabled={false}
                        dropdownType="normal"
                        arrayOoptionList={ReportsStagesList}
                        KeyText={"stagesName"}
                        KeyValue={"pR_ReportsStagesGuid"}
                        defaultValue={props.tackAction == "edit" ? expectedObjectivesForStage?.
                            pR_ReportsStages?.
                            pR_StagesNumber?.
                            stagesName
                            : ""}
                        onChange={(e) => {
                            setReportsStages(e.target.value);
                        }}
                        showValidationMessage={
                            reportsStagesValidation
                        }
                        validationMessage="يرجى تعبئة هذا الحقل"
                    />
                    <AllDropDownsAHSF
                        fieldsName="ExObjectives"
                        show={true}
                        disabled={false}
                        dropdownType="normal"
                        arrayOoptionList={objectiveProjectsList}
                        KeyText={"objectiveName"}
                        KeyValue={"pR_ObjectiveProjectsId"}
                        defaultValue={props.tackAction == "edit" ? expectedObjectivesForStage?.
                            pR_ObjectiveProjects?.
                            objectiveName : ""}
                        onChange={(e) => {
                            setObjectives(e.target.value);
                        }}
                        showValidationMessage={
                            ObjectivesValidation
                        }
                        validationMessage="يرجى تعبئة هذا الحقل"
                    />

                    <InputAHSF
                        fieldsName="SubObjectives"
                        show={true}
                        disabled={false}
                        comma={false}
                        onChange={(e) => {
                            setSubObjectives(e.target.value)
                        }}
                        defaultValue={props.tackAction == "edit" ? expectedObjectivesForStage?.subObjectives : ""}
                        showValidationMessage={
                            SubObjectivesValidation
                        }
                        validationMessage="يرجى تعبئة هذا الحقل"
                    />
                    <InputAHSF
                        fieldsName="SubObjectivesPercentage"
                        show={true}
                        
                        disabled={false}
                        comma={true}
                        onChange={(e) => {
                            setSubObjectivesPercentage(e.target.value)
                        }}
                        defaultValue={props.tackAction == "edit" ? expectedObjectivesForStage?.percentageMainAndSubObjecive : ""}
                        showValidationMessage={
                            subObjectivesPercentageValidation
                        }
                        validationMessage="يرجى تعبئة هذا الحقل"
                    />
                </>
            }

            {
                props.tackAction == "edit" ? <><div className='containerButton'>
                    <button className="custom-button" onClick={editExpectedObjectivesForReport}>
                        تعديل
                    </button>
                </div ></> : <><div className='containerButton'>
                    <button className="custom-button" onClick={addExpectedObjectivesForReport}>
                        حفظ
                    </button>
                </div></>
            }


        </>
    )
}

export default AddExpectedObjectivesForReport

